import {
	_t,
	barkApi,
	bugsnagClientNotify,
	tracking as barkTrackingLogEvent,
	formatPhoneNumber,
} from '@bark/bark-core';

import { Button as SellerButton } from '../seller-toolbar/toolbar_button';

export const cfbLogTrackingEvent = (eventName, data) => {
	barkTrackingLogEvent('seller-leads-dashboard-&-responses', eventName, {
		project_age: data?.projectCreated,
		primary_category: data?.categoryName,
		page: window.location.pathname,
		seller_profile_id: data?.seller_profile_id,
		project_id: data?.project_id,
	});
};



export const callFeedbackModalTracking = ({
	seller_profile_id,
	project_id,
	buyer_id,
	booking_id,
	seller_call_feedback_sms = false,
}) => {
	return (eventName, additionalProperties) =>
		barkTrackingLogEvent('Seller-responses-call-feedback-modal', eventName, {
			seller_profile_id,
			project_id,
			buyer_id,
			booking_id,
			seller_call_feedback_sms,
			...additionalProperties,
		});
};




export const cfbAddCopyToClipboardButton = ($container) => {
	const { Handlebars } = window;

	let copyToClipBtnTemplate = Handlebars.compile(
		document.getElementById('copy-to-clip-btn-template').innerHTML,
	);
	let btnHtml = copyToClipBtnTemplate({
		text: {
			copied: _t('seller_common:copied-label'),
		},
	});

	$container.append(btnHtml);
};

export const cfbRemoveCopyToClipboardButton = ($container) => {
	$container.find('.copy-to-clip-btn-container').remove();
};

export const cfbBindCopyToClipboardButtonListener = ($container, data) => {
	let $copyClipBtnContainer = $container.find('.copy-to-clip-btn-container');
	$copyClipBtnContainer.removeClass('success');

	let $copyClipBtn = $copyClipBtnContainer.find('.copy-to-clip-btn');
	$copyClipBtn.off('click').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		if (navigator.clipboard) {
			navigator.clipboard.writeText(data.buyerNumber);
		}

		$copyClipBtnContainer.addClass('success');
		setTimeout(function () {
			$copyClipBtnContainer.removeClass('success');
		}, 3000);

		cfbLogTrackingEvent('call_feedback - copy-number-button-clicked', data);
	});
};

export const cfbDisplayShowNumberLink = () => {
	$('.buyer-telephone-display').addClass('d-sm-none');
	$('.buyer-telephone-show-link').addClass('d-sm-flex');
};

export const cfbResetDisplayShowNumberLink = () => {
	$('.buyer-telephone-display').removeClass('d-sm-none');
	$('.buyer-telephone-show-link').removeClass('d-sm-flex');
};

export const cfbDisplayPhoneNumberOnMobileButton = ($link, $button, phoneNumber) => {
	let { phoneNumberToDial, phoneNumberToDisplay } = formatPhoneNumber(phoneNumber);
	$link.attr('href', phoneNumberToDial);
	$button.text(phoneNumberToDisplay);
};

export const cfbLeadsPageAddCallButtons = (callFeedbackModal) => {
	const { Handlebars } = window;

	const SellerResponseFlowButtonTemplate = Handlebars.compile(
		document.getElementById('seller-response-flow-button-template').innerHTML,
	);

	let buttonCallDesktopNew = new SellerButton({
		name: 'seller-call-desktop-new',
		icon_end: 'open_in_new',
		template: SellerResponseFlowButtonTemplate,
		label: _t('seller_common:show-number-button'),
		params: {},
		callback: () => {
			callFeedbackModal.show();
			cfbLogTrackingEvent('call_feedback - show-number-button-clicked', {
				projectCreated: callFeedbackModal.getFromState('projectCreated'),
				categoryName: callFeedbackModal.getFromState('categoryName'),
			});
		},
		conditions: [() => true],
		container_class: 'response-button-call-container-desktop-new',
	});
	buttonCallDesktopNew.render();

	let buttonCallMobileNew = new SellerButton({
		name: 'seller-call-mobile-new',
		icon: 'telephone',
		template: SellerResponseFlowButtonTemplate,
		params: {},
		prevent_default: false,
		callback: () => {
			callFeedbackModal.show();
			cfbLogTrackingEvent('call_feedback - button-with-number-clicked', {
				projectCreated: callFeedbackModal.getFromState('projectCreated'),
				categoryName: callFeedbackModal.getFromState('categoryName'),
				project_id: callFeedbackModal.getFromState('project_id'),
			});
		},
		conditions: [() => true],
		container_class: 'response-button-call-container-mobile-new',
	});
	buttonCallMobileNew.render();
};
